export const billingDetailsGQLFields = () => `
  address {
    city
    country
    postalCode
    state
    streetAddress
  }
  billingEmail
  card {
    expirationMonth
    expirationYear
    lastFourDigits
    updatedAt
  }
  companyName
  vat {
    text
    vatId
    vatType
  }
`
